import { render, staticRenderFns } from "./GoodsMarketBoard.vue?vue&type=template&id=5e6c423c"
import script from "./GoodsMarketBoard.vue?vue&type=script&lang=js"
export * from "./GoodsMarketBoard.vue?vue&type=script&lang=js"
import style0 from "./GoodsMarketBoard.vue?vue&type=style&index=0&id=5e6c423c&prod&lang=css"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports